import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import { colors } from '../../../styles/colors';
export const Breadcrumbs = ({ items }) => {
    const navigate = useNavigate();
    const handleClick = (e, path) => {
        e.preventDefault();
        if (path) {
            navigate(path);
        }
    };
    return (_jsx(MuiBreadcrumbs, Object.assign({ separator: _jsx(NavigateNextIcon, { fontSize: "small", sx: { color: colors.textHint } }), sx: { marginBottom: '16px' } }, { children: items.map((item, index) => {
            const isLast = index === items.length - 1;
            if (isLast) {
                return (_jsxs(Typography, Object.assign({ sx: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        color: colors.textPrimary,
                        fontWeight: 500,
                    } }, { children: [item.icon, item.label] }), item.label));
            }
            return (_jsxs(Link, Object.assign({ href: item.path || '#', onClick: (e) => handleClick(e, item.path), sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    color: colors.textSecondary,
                    textDecoration: 'none',
                    '&:hover': {
                        color: colors.textPrimary,
                        textDecoration: 'underline',
                    },
                } }, { children: [index === 0 && !item.icon && _jsx(HomeIcon, { fontSize: "small" }), item.icon, item.label] }), item.label));
        }) })));
};
